import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { useTranslation } from "react-i18next";

export interface InnerCrudFormHeaderProps {
  onClickBack?: () => void;
  title: string;
  disabled?: boolean;
  editActions?: React.ReactNode;
}

export function InnerCrudFormHeader({
  onClickBack,
  title,
  disabled,
  editActions,
}: InnerCrudFormHeaderProps) {
  const { t } = useTranslation();

  return (
    <AppBar
      position="sticky"
      sx={{ bgcolor: "background.paper" }}
      elevation={0}
    >
      <Toolbar>
        <IconButton
          sx={{ marginRight: "10px" }}
          edge="start"
          component="a"
          href="#back"
          onClick={(e) => {
            e.preventDefault();
            onClickBack?.();
          }}
          size="large"
        >
          <ArrowBackIcon />
        </IconButton>

        <Typography variant="h6" color="inherit" sx={{ flex: 1 }}>
          {title}
        </Typography>

        <Stack spacing={1} direction="row">
          {editActions}

          <Button
            variant="contained"
            color="primary"
            type="submit"
            disabled={disabled}
          >
            {t("shared.form.submit", { defaultValue: "Сохранить" })}
          </Button>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}

InnerCrudFormHeader.propTypes = {
  onClickBack: PropTypes.func,
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};
